import React from 'react';
import { BX24 } from 'bx24';
import { User, useAuth } from '../../hooks/useAuth';

import axios from 'axios';

import { apiBaseUrl } from '../../api/base';

import {
    Container
} from './styles';

const Loginpage: React.FC = () => {

    const { setUser } = useAuth();

    async function getBitrixData() {
        try {
            const bx24 = new BX24(window, parent);
            // const urlParams = new URLSearchParams(window.location.href);
            // const domain = urlParams.get('DOMAIN');
            // const baseUrl = https://${urlParams.get('DOMAIN')};

            var auth = await bx24.getAuth();
            const access_token = auth.ACCESS_TOKEN;
            const domain = auth.DOMAIN;
            const baseUrl = 'https://' + domain;

            let codUserBitrixResp: any;
            await axios.post(baseUrl + '/rest/profile?auth=' + access_token)
                .then(response => {
                    codUserBitrixResp = response.data.result.ID;

                })
                .catch((e) => {
                    console.log(e.message)
                });

            return { domain, codUserBitrixResp };
        } catch (e) {
            console.log(e)
        }
    }

    function sendToApi() {

        const bitrixData = getBitrixData();

        return bitrixData.then(r => {
            var config = {
                method: 'get',
                url: apiBaseUrl + '/users/getAuth',
                params: {
                    codBitrix: r?.codUserBitrixResp,
                    domainClient: r?.domain
                }
            }
            return axios(config)
                .then(function (response) {
                    const res: User =
                    {
                        name: response.data.userName,
                        codUser: response.data.codBitrix,
                        permissions: response.data.permissoes,
                        client: response.data.clientName,
                        codClient: response.data.clientId,
                        clientJiraCodMain: response.data.jiraMainIssue,
                        clientJiraCodSup: response.data.jiraSupportIssue,
                    }

                    return res;
                })
                .catch((e) => {
                    console.log(e.message)
                });

        })
    }

    async function logIn() {

        const res = await sendToApi();

        if (res) {
            setUser({
                name: res.name,
                codUser: res.codUser,
                permissions: res.permissions,
                client: res.client,
                codClient: res.codClient,
                clientJiraCodMain: res.clientJiraCodMain,
                clientJiraCodSup: res.clientJiraCodSup
            });
        } else {
            alert('Usuário sem autorização.')
        }
    }

    return (
        <Container>
            <h1>Boas-vindas a área do cliente Nia!</h1>
            <button onClick={async () => { await logIn() }}><h2>Acessar!</h2></button>
        </Container>
    )
}

export default Loginpage;